<template>
    <div>
        <Hero />
        <div class="px-8 md:p-20">
            <About />
            <GetAccquintedOne />
        </div>
        <Sermon class="px-8 md:p-20 pb-10 pt-5 md:py-10"/>
        <Events class=""/>
        <BecomeOurFamily />
        <GetAccquintedTwo class="px-8 md:p-20" />
    </div>
</template>

<script setup>
import Hero from '../components/Home/Hero.vue';
import About from '../components/Home/About.vue';
import GetAccquintedOne from '../components/Home/GetAccquintedOne.vue';
import Sermon from '../components/Home/Sermon.vue'
import Events from '../components/Home/Events.vue';
import BecomeOurFamily from '../components/BecomeOurFamily.vue';
import GetAccquintedTwo from '../components/Home/GetAccquintedTwo.vue';
</script>

<style lang="scss" scoped>

</style>